'use client'

import StackIcon from '@/components/content/stacks/shared/StackIcon'
import Breadcrumb from '@/components/content/sidebar/Breadcrumb'
import Menu from '@/components/ui/Menu'

import { Icon } from '@/icons/Icon'
import { generateMenu } from '@/helpers/menus'
import type { Stack, App } from '@/payload-types'

type StackSidebarProps = {
  stack: Pick<
    Stack,
    'slug' | 'icon' | 'name' | 'summary' | 'notes' | 'stackApps' | 'stackFaqs' | 'updatedAt'
  >
  apps: App[]
}

export default function StackSidebar({ stack, apps }: StackSidebarProps) {
  const menu = generateMenu('app', {
    app: apps,
  })

  return (
    <div className="flex w-full flex-row items-center gap-3.5 md:flex-col md:items-start md:p-4 lg:flex-row lg:items-center">
      <div className="flex min-w-0 flex-1 items-center gap-3.5 lg:w-[calc(100%-124px)]">
        <div className="squircle flex h-8 w-8 items-center justify-center border border-gray-200 bg-gray-50 dark:border-white/10 dark:bg-white/10 md:hidden">
          <Icon name="stack" className="text-gray-500 dark:text-white/60" />
        </div>

        <div className="hidden md:block">
          <StackIcon apps={apps.slice(0, 4)} />
        </div>

        <div className="hidden flex-col items-start gap-0.5 leading-tight md:mt-1 md:flex md:w-full lg:w-[calc(100%-70px)]">
          <span className="truncate font-semibold text-gray-950 dark:text-white">{stack.name}</span>
          <span className="truncate text-13 text-gray-600 dark:text-zinc-500">
            {apps.length} app{apps.length === 1 ? '' : 's'} stack
          </span>
        </div>
        <Breadcrumb placeholder="Stack" title={stack.name} />
      </div>
      {menu.length > 0 && (
        <div className="flex shrink-0 gap-2.5 lg:ml-auto">
          <Menu items={menu} align="right" subAlign="down" />
        </div>
      )}
    </div>
  )
}
